import React from "react";

const Button = ({ text, onClick, disabled = false,icon,iconPosition,themeMode , className = "" }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`min-w-[5rem] flex-shrink-0  flex justify-center items-center border rounded-[0.375rem] 
      border-white-09 cursor-pointer hover:bg-[#3575DE] bg-[#205DC2] 
      disabled:cursor-not-allowed 
      ${themeMode === "dark" 
        ? "text-white disabled:text-white-4 disabled:bg-white-02"
        : "text-white disabled:text-black-4 disabled:bg-black-06"} 
      ${className}`}
    >
     {icon && iconPosition === "left" && <div className="mr-2">{icon}</div>}
  
  <span>{text}</span>
  
  {icon && iconPosition === "right" && <div className="ml-2">{icon}</div>}
    </button>
  );
};

export default Button;
